import {
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { findIndex, isEmpty } from "lodash";
import { getInputDateFormats } from "../../../utils/get-date-time-locale";

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { useCommittees } from "../../../hooks/useCommittees";
import { useFormCombos } from "../../../hooks/useFormCombos";
import { useSlots } from "../../../hooks/useSlots";
import { actionShowSpinner } from "../../../redux-flow/action/Wrapper/Spinner";
import { getAllCommitteesByLanguageId } from "../../../services/committees.service";
import { getCompaniesByCommittees } from "../../../services/companies.service";
import { getMembersByName } from "../../../services/formCombos.service.js";
import {
  deletedSlot,
  disabledSlot,
  enableSlot,
  updateSlotCommittee,
} from "../../../services/slots.service";
import DialogCustom from "../../Common/DialogCustom";
import { Select } from "../../Common/Select";
import Textarea from "../../Common/Textarea";
import Toastmessage from "../../Common/ToastMessage";
import { checkAccess, formatCurrencyInputValue } from "../utils/index";
import CommitteCard from "./CommitteCard";
import { FieldInfo, TitleContainer } from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
    width: "100%",
  },
  cancelIcon: {
    color: theme.palette.error.main,
  },
  subtitle: {
    ...theme.typography.subtitle1,
  },
  button: {
    fontSize: "1rem",
    fontWeight: "bold",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20,
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.25rem",
    color: theme.palette.primary.main,
    marginBottom: 20,
  },
}));

const FormSlot = ({ t, i18n, match, history, actionShowSpinner, disabled }) => {
  const classes = useStyles();
  const { userAccess } = useAuth();

  const [objValue, setValue] = useState({ modalities: [], companies: [] });
  const [hostList, setHostList] = useState([]);

  const [committeeList, setCommitteeList] = useState([]);
  const [committeeListPost, setCommitteeListPost] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [themeValue, setThemeValue] = useState();
  const [objectiveValue, setObjectiveValue] = useState();
  const [requesterName, setRequesterName] = useState("");
  const [presenterName, setPresenterName] = useState("");
  const [presenterOptions, setPresenterOptions] = useState([]);
  const [requesterOptions, setRequesterOptions] = useState([]);
  const [checkDisabled, setCheckDisabled] = useState(false);
  const [disable, setDisable] = useState(false);
  const [anyoneCanHost, setAnyoneCanHost] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [caveatsValue, setCaveatsValue] = useState();

  const [message, setMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });

  const {
    params: { id },
  } = match;

  const {
    getMembers,
    getDirectors,
    directorsList,
    modalityList,
    getMonths,
    getAllModalityByLanguageId,
    getAllThemesByLanguageId,
    sanitizeDirectorsForSelect,
    getStatusSlot,
    getStatusMaterial,
    statusMaterial,
    getTypeSlot,
    typeSlot,
    getCurrencies,
    currencies,
  } = useFormCombos();

  const { create, update, success, getSlot, error, slot } = useSlots({
    spinner: actionShowSpinner,
  });

  const [committeesListSelect, setCommitteeListSelect] = useState([]);

  const [slotCommitteeId, setSlotCommitteeId] = useState();
  const [editSlotCommittee, setEditSlotCommittee] = useState();
  const [returnUrl, setReturnUrl] = useState();

  const [extraSlot, setExtraSlot] = useState(false);
  const [canCreateSlot, setCanCreateSlot] = useState(false);
  const [committeeIdToDelere, setCommitteeIdToDelere] = useState();
  const [deleteCommitteeAlertOpened, setDeleteCommitteeAlertOpened] =
    useState(false);
  const [canDeleteSlot, setCanDeleteSlot] = useState(false);
  const [canDisableSlot, setCanDisableSlot] = useState(false);
  const [canUpdateSlot, setCanUpdateSlot] = useState(false);
  const [canCreateExtraSlot, setCanCreateExtraSlot] = useState(false);
  const [duplicateSlot, setDuplicateSlot] = useState();
  const [slotIdToDuplicate, setSlotIdToDuplicate] = useState();
  const [detailSlot, setDetailSlot] = useState(false);
  const [detailSlotId, setDetailSlotId] = useState();
  const [companiesOptions, setCompaniesOptions] = useState([]);

  const { finalElevationList, getFinalElevationByLanguageId } = useCommittees({
    spinner: actionShowSpinner,
  });

  const materialSupportStatusOptions = useMemo(() => {
    return statusMaterial.filter((s) => s.id !== 1);
  }, [statusMaterial])

  const fillSlot = useCallback(
    (items) => {
      const slotHosts = items.slotHosts.map((host) => ({
        id: host.userId,
        name: host.userName,
      }));

      setHostList(slotHosts);

      setCommitteeList(items.committees);

      const initialCurrency = currencies.find((c) => c.id === items.currency);

      var presenter = undefined;

      if (!items.anyoneCanHost) {
        presenter = { id: items.hostId, name: items.hostName };
      }

      var requester = undefined;

      if (!!items.requestName && !!items.requestId) {
        requester = { id: items.requestId, name: items.requestName };
      }

      const board = { id: items.directory, name: items.directoryName };
      const type = typeSlot.find((ts) => ts.id === items.kind);
      const finalElevation = finalElevationList.find(
        (f) => f.id === items.committeeFinalAuthority
      );
      const status = statusMaterial.find(
        (s) => s.id === Number(items.materialSupportStatus)
      );

      const utcDate = new Date(slot.meetDateTime);

      let slotDateInCurrentTime = new Date(utcDate);

      slotDateInCurrentTime.setHours(new Date().getHours());
      slotDateInCurrentTime.setMinutes(new Date().getMinutes());
      slotDateInCurrentTime.setSeconds(new Date().getSeconds());

      if (!slot.meetDateTime) {
        slotDateInCurrentTime = null;
      }

      setValue({
        currency: initialCurrency,
        objective: items.objective,
        theme: items.slotThemeName,
        presenter,
        board,
        type,
        finalElevation,
        modalities: items.modalities.map((m) => ({
          id: m.modalityId,
          name: m.modalityName,
        })),
        status,
        institution: items.institution,
        sponsor: items.sponsor,
        value: items.value
          ? formatCurrencyInputValue(items.value.slice(0, -2))
          : "",
        budgetedValue: items.budgetedValue
          ? formatCurrencyInputValue(items.budgetedValue.slice(0, -2))
          : "",
        requestedValue: items.requestedValue
          ? formatCurrencyInputValue(items.requestedValue.slice(0, -2))
          : "",
        additive: items.additive
          ? formatCurrencyInputValue(items.additive.slice(0, -2))
          : "",
        amountNotBudgetedYear: items.amountNotBudgetedYear
          ? formatCurrencyInputValue(items.amountNotBudgetedYear.slice(0, -2))
          : "",
        multiannualBudgetAmount: items.multiannualBudgetAmount
          ? formatCurrencyInputValue(items.multiannualBudgetAmount.slice(0, -2))
          : "",
        duration: items.duration,
        meetingDate: slotDateInCurrentTime,
        requester,
        budget: items.budgeted,
        projectIdentifier: items.projectIdentifier,
        createdIn: items.createdDateTime,
        companies: items.companies.map((cp) => ({
          id: cp.companyId,
          name: `${cp.companyName} - ${cp.companyAbbreviation}`,
        })),
      });

      setAnyoneCanHost(items?.anyoneCanHost ? items.anyoneCanHost : false);
      setThemeValue(items.slotThemeName);
      setObjectiveValue(items.objective);
      setCaveatsValue(items.caveats);
      setExtraSlot(items.extraSlot);

      setSelectedDate(slotDateInCurrentTime);
    },
    [currencies, typeSlot, finalElevationList, slot, statusMaterial]
  );

  useEffect(() => {
    async function load() {
      if (presenterName?.length >= 3) {
        const res = await getMembersByName("pt", presenterName);

        if (res.error?.length > 0) {
          setPresenterOptions([]);
        }

        setPresenterOptions(res.data);
      } else {
        setPresenterOptions([]);
      }

      if (requesterName?.length >= 3) {
        const res = await getMembersByName("pt", requesterName);

        if (res.error?.length > 0) {
          setRequesterOptions([]);
        }

        setRequesterOptions(res.data);
      } else {
        setRequesterOptions([]);
      }
    }

    const delayDebounceFn = setTimeout(() => {
      load();
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [presenterName, requesterName]);

  useEffect(() => {
    if (typeof editSlotCommittee === "boolean") {
      if (editSlotCommittee) {
        getSlot(id, slotCommitteeId);

        return;
      }

      getSlot(id);
      return;
    }

    if (duplicateSlot) {
      getSlot(slotIdToDuplicate);

      return;
    }

    if (detailSlot) {
      getSlot(detailSlotId);

      return;
    }
  }, [
    id,
    editSlotCommittee,
    duplicateSlot,
    slotIdToDuplicate,
    slotCommitteeId,
    detailSlotId,
    detailSlot,
  ]);

  useEffect(() => {
    setDuplicateSlot(history?.location?.state?.duplicateSlot);
    setSlotIdToDuplicate(history?.location?.state?.slotIdToDuplicate);
    setDetailSlot(history?.location?.state?.detailSlot);
    setDetailSlotId(history?.location?.state?.slotId);

    if (
      !!history?.location?.state?.extraSlot &&
      typeof history?.location?.state?.extraSlot === "boolean"
    ) {
      setExtraSlot(true);
    }

    if (history?.location?.state?.extraSlotInfo) {
      setValue({
        ...objValue,
        meetingDate: history?.location?.state?.extraSlotInfo.defaultDate,
      });
      setSelectedDate(history?.location?.state?.extraSlotInfo.defaultDate);
      setCommitteeList([history?.location?.state?.extraSlotInfo.committee]);
    }

    setEditSlotCommittee(history?.location?.state?.editSlotCommittee);
    setReturnUrl(history?.location?.state?.returnUrl);
    setSlotCommitteeId(history?.location?.state?.slotCommitteeId);
  }, [history]);

  const fetchCompanies = async (committeeIds) => {
    const companies = await getCompaniesByCommittees(committeeIds);

    setCompaniesOptions(companies);
  };

  useEffect(() => {
    const loadList = async () => {
      actionShowSpinner(true);

      const response = await getAllCommitteesByLanguageId(i18n.language);

      actionShowSpinner(false);

      setCommitteeListSelect(
        response.data.filter((committee) => committee.status !== "Inativo")
      );
    };

    if (userAccess) {
      const hasAccessToCreateExtraSlot = checkAccess(
        userAccess,
        "createExtraSlot"
      );
      const hasAccessToCreateSlot = checkAccess(userAccess, "createSlot");
      const hasAccessToDeleteSlot = checkAccess(userAccess, "deleteSlot");
      const hasAccessToDisableSlot = checkAccess(userAccess, "disableSlot");
      const hasAccessToUpdateSlot = checkAccess(userAccess, "updateSlot");

      setCanCreateSlot(hasAccessToCreateSlot);
      setCanDeleteSlot(hasAccessToDeleteSlot);
      setCanDisableSlot(hasAccessToDisableSlot);
      setCanUpdateSlot(hasAccessToUpdateSlot);
      setCanCreateExtraSlot(hasAccessToCreateExtraSlot);

      if (i18n.language) {
        getMonths(i18n.language);
        getAllModalityByLanguageId(i18n.language, false);
        getMembers(i18n.language);
        getDirectors(i18n.language);

        loadList();

        getFinalElevationByLanguageId(i18n.language);
        getCurrencies(i18n.language);
        getStatusSlot(i18n.language);
        getStatusMaterial(i18n.language);
        getTypeSlot(i18n.language);
        getAllThemesByLanguageId(i18n.language);
      }
    }
  }, [i18n.language, userAccess]);

  const committeesOptions = useMemo(() => {
    return committeesListSelect.filter(
      (item) => !committeeList.find((committee) => committee.id === item.id)
    );
  }, [committeesListSelect, committeeList]);

  const handleChange = (event) => {
    setValue({ ...objValue, [event.target.name]: event.target.value });
  };

  const handleChangeSelect = (selected, name) => {
    setValue({ ...objValue, [name]: selected });
  };

  const handleDateChange = (date) => {
    const slotDateInCurrentTime = new Date(date);

    slotDateInCurrentTime.setHours(new Date().getHours());
    slotDateInCurrentTime.setMinutes(new Date().getMinutes());
    slotDateInCurrentTime.setSeconds(new Date().getSeconds());

    setSelectedDate(date ? slotDateInCurrentTime : undefined);
    setValue({ ...objValue, meetingDate: date });
  };

  useEffect(() => {
    if (id && !isEmpty(slot)) {
      fillSlot(slot);
      setDisable(slot.status !== "I" ? true : false);
    }

    if (duplicateSlot && !isEmpty(slot)) {
      fillSlot({ ...slot, meetDateTime: null });
    }

    if (detailSlot && !isEmpty(slot)) {
      fillSlot(slot);
    }
  }, [slot, detailSlot, fillSlot, id, duplicateSlot]);

  useEffect(() => {
    if (success.disable === "disable") {
      setMessage({
        open: true,
        content: "Status alterado com sucesso!",
        type: "success",
      });
    }
    if (success.create === "create") {
      history.push({
        pathname: returnUrl ? returnUrl : "/slots",
        state: { successCreateSlot: true },
      });
    }
    if (success.update === "update") {
      history.push({
        pathname: returnUrl ? returnUrl : "/slots",
        state: { successUpdateSlot: true },
      });
    }
  }, [success]);

  useEffect(() => {
    if (error.create) {
      setMessage({
        open: true,
        content: error.create,
        type: "error",
        autoHideDuration: null,
      });
    }
    if (error.update) {
      setMessage({
        open: true,
        content: error.update,
        type: "error",
        autoHideDuration: null,
      });
    }
  }, [error]);

  useEffect(() => {
    const committeesIds = committeeList.map((cmt) => cmt.id);

    fetchCompanies(committeesIds);
  }, [committeeList]);

  const handleChangeDisable = async (event) => {
    const response = disable
      ? await disabledSlot({ id: slotCommitteeId, disabled: checkDisabled })
      : await enableSlot({ id: slotCommitteeId, disabled: checkDisabled });

    if (response.error.length > 0) {
      setMessage({
        open: true,
        content:
          response.error === "async"
            ? `Não foi possível ${
                disable ? "desativar" : "ativar"
              } o slot, tente novamente.`
            : response.error,
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    setDisable(event.target.checked);
    setOpen(false);

    history.push({
      pathname: returnUrl ? returnUrl : "/slots",
      state: disable
        ? { successDisabledSlot: true }
        : { successEnabledSlot: true },
    });
  };

  const handleChangeDelete = async (event) => {
    const response = await deletedSlot({ id });

    setOpenDelete(false);

    if (response.error) {
      setMessage({
        open: true,
        content: t("slotDeleteError"),
        type: "error",
        autoHideDuration: 8000,
      });

      return;
    }

    history.push({
      pathname: returnUrl ? returnUrl : "/slots",
      state: { successDeleteSlot: true },
    });
  };

  const handleSave = async () => {
    actionShowSpinner(true);

    if (
      objValue.budget === "yes" &&
      !objValue.budgetedValue &&
      !objValue.multiannualBudgetAmount &&
      !objValue.amountNotBudgetedYear &&
      !objValue.requestedValue &&
      !objValue.value &&
      !objValue.additive 
    ) {
      setMessage({
        open: true,
        content: "Preencha todos os campos obrigatórios",
        type: "error",
        autoHideDuration: 4000,
      });

      actionShowSpinner(false);

      return;
    } else if (objValue.budget === "pno" && !objValue.budgetedValue) {
      setMessage({
        open: true,
        content: "Valor orçado no ano é obrigatório",
        type: "error",
        autoHideDuration: 4000,
      });

      actionShowSpinner(false);

      return;
    }

    if(!selectedDate || !objValue.meetingDate) {
      setMessage({
        open: true,
        content: "É obrigatório informar a data da reunião.",
        type: "error",
        autoHideDuration: 4000,
      });

      actionShowSpinner(false);

      return;
    }

    setMessage({
      open: false,
      content: "",
      type: "",
      autoHideDuration: 4000,
    });

    var committePost = committeeList.map((item) => {
      return {
        id: item.id,
        name: item.name,
        finalAuthority: item.finalAuthority,
      };
    });

    const saoPauloOffset = -3 * 60; // Sao Paulo is UTC-3

    const utcDate = new Date(selectedDate);

    const formattedSelectedDate = new Date(
      utcDate.getTime() + saoPauloOffset * 60 * 1000
    );

    const request = {
      extraSlot,
      requestId: objValue.requester ? objValue.requester.id : null,
      ...(objValue.value && {
        valueSlot: Number(String(objValue.value.replaceAll(".", ""))),
      }),
      ...(objValue.budgetedValue && {
        budgetedValue: Number(
          String(objValue.budgetedValue.replaceAll(".", ""))
        ),
      }),
      ...(objValue.requestedValue && {
        requestedValue: Number(
          String(objValue.requestedValue.replaceAll(".", ""))
        ),
      }),
      ...(objValue.multiannualBudgetAmount && {
        multiannualBudgetAmount: Number(
          String(objValue.multiannualBudgetAmount.replaceAll(".", ""))
        ),
      }),
      ...(objValue.amountNotBudgetedYear && {
        amountNotBudgetedYear: Number(
          String(objValue.amountNotBudgetedYear.replaceAll(".", ""))
        ),
      }),
      ...(objValue.additive && {
        additive: Number(String(objValue.additive.replaceAll(".", ""))),
      }),
      projectIdentifier: objValue.projectIdentifier,
      hostId:
        anyoneCanHost || !objValue.presenter?.id ? null : objValue.presenter.id,
      directory: (objValue.board && objValue.board.id) || null,
      kind: (objValue.type && objValue.type.id) || "",
      budgeted: objValue.budget,
      modalities: objValue.modalities.map((item) => item.id),
      objective: objectiveValue,
      institution: objValue.institution,
      duration: objValue.duration,
      caveats: caveatsValue,
      sponsor: objValue.sponsor,
      ...(selectedDate && { meetDateTime: formattedSelectedDate }),
      slotThemeName: themeValue,
      committees: committePost,
      hosts: hostList.map((host) => host.id),
      materialSupportStatus: (objValue.status && objValue.status.id) || "",
      anyoneCanHost,
      ...(objValue?.currency?.id && { currency: objValue.currency.id }),
      ...(objValue?.companies?.length > 0 && {
        companyId: objValue.companies.map((cp) => cp.id),
      }),
    };
    if (!id) {
      await create(request);
    } else if (!editSlotCommittee) {
      await update(id, request);
    } else {
      await updateSlotCommittee({
        meetDate: formattedSelectedDate,
        slotCommitteeId,
      });

      actionShowSpinner(false);

      history.push({
        pathname: returnUrl ? returnUrl : "/slots",
        state: { successUpdateSlot: true },
      });
    }
  };

  const handleAddCommittee = (selectedCommittee) => {
    const newCommitteeList = [...committeeList];

    newCommitteeList.push(
      newCommitteeList.length < 1
        ? {
            id: selectedCommittee.id,
            nameCommittee: selectedCommittee.name,
            finalAuthority: true,
          }
        : {
            id: selectedCommittee.id,
            nameCommittee: selectedCommittee.name,
            finalAuthority: false,
          }
    );
    setCommitteeList(newCommitteeList);

    const listPost = [...committeeListPost];
    listPost.push(selectedCommittee.id);

    setCommitteeList(newCommitteeList);
    setCommitteeListPost(listPost);

    setValue({ ...objValue, ["committee"]: null });
  };

  const handleAddHost = (selectedHost) => {
    const listHostAddOld = [...hostList];

    listHostAddOld.push({
      id: selectedHost.id,
      name: selectedHost.name,
    });

    setHostList(listHostAddOld);
    setValue({ ...objValue, ["host"]: null });
  };

  const handleDeleteElevation = () => {
    const newFinalElevation = committeeList
      .filter((item) => item.id !== committeeIdToDelere)
      .map((_item, index) => {
        if (index === 0) {
          return { ..._item, finalAuthority: true };
        }

        return { ..._item, finalAuthority: false };
      });

    setDeleteCommitteeAlertOpened(false);
    setCommitteeList(newFinalElevation);
  };

  const handleSetFinalElevation = (committeeId) => {
    const newFinalElevation = committeeList.map((item) => {
      if (item.id === committeeId) {
        return { ...item, finalAuthority: true };
      }
      return { ...item, finalAuthority: false };
    });

    setCommitteeList(newFinalElevation);
  };

  const handleDeleteHost = (idHost) => {
    const newHost = [...hostList];

    const idx = findIndex(newHost, ["id", idHost]);
    newHost.splice(idx, 1);
    setHostList(newHost);
  };

  const handleClickOpen = (event) => {
    setCheckDisabled(event.target.checked);
    setOpen(true);
  };

  const handleDeleteClickOpen = (event) => {
    setOpenDelete(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const getStatus = (status) => {
    switch (status) {
      case "I":
        return t("slots.status.inactive");
      case "A":
        return t("slots.status.active");
      case "C":
        return t("slots.status.conclued");
      case "F":
        return t("slots.status.confirmed");
      case "P":
        return t("slots.status.planned");
      default:
        return "";
    }
  };

  return (
    <Grid container className={classes.root}>
      <Grid
        container
        item
        direction="row"
        justify="space-between"
        className={classes.spacer}
      >
        <Grid item xs={12} md={6} lg={6}>
          <Typography variant="h4">
            {disabled ? t("slots.preview") : t(`slots.${id ? "edit" : "new"}`)}
          </Typography>
        </Grid>

        <Toastmessage
          message={message.content}
          type={message.type}
          open={message.open}
          autoHideDuration={message.autoHideDuration}
          close={() =>
            setMessage({
              open: false,
              content: "",
              type: "",
              autoHideDuration: 4000,
            })
          }
        />

        {id && (
          <Grid
            container
            item
            direction="row"
            md={6}
            lg={6}
            alignItems="center"
            justify="center"
          >
            <Grid item xs={6} md={6} lg={6}>
              {!disabled && editSlotCommittee && (
                <FormControlLabel
                  control={
                    <Tooltip title={disable ? t("deactivate") : t("activate")}>
                      <Switch
                        checked={disable}
                        onChange={handleClickOpen}
                        name="disable"
                        color="primary"
                        disabled={!editSlotCommittee || !canDisableSlot}
                        tool
                      />
                    </Tooltip>
                  }
                  label={disable ? t("active") : t("inactive")}
                  className={classes.subtitle}
                />
              )}
            </Grid>

            {!disabled && !editSlotCommittee && (
              <Grid item>
                <IconButton
                  onClick={() => {
                    if (canDeleteSlot) {
                      handleDeleteClickOpen(i18n.language, id);
                    }
                  }}
                  disabled={editSlotCommittee || !canDeleteSlot}
                >
                  <CancelIcon className={classes.cancelIcon} />
                </IconButton>
              </Grid>
            )}

            {!disabled && !editSlotCommittee && (
              <Grid item>
                <Typography
                  className={classes.iconText}
                  onClick={() => {
                    if (canDeleteSlot) {
                      handleDeleteClickOpen(i18n.language, id);
                    }
                  }}
                  disabled={editSlotCommittee || !canDeleteSlot}
                >
                  {t("forms.dialog.delete")}
                </Typography>
              </Grid>
            )}
          </Grid>
        )}

        <div>
          <DialogCustom
            open={open}
            handleClose={handleClose}
            handleChange={handleChangeDisable}
            title={t(`forms.dialog.alert`)}
            body={
              disable
                ? t("forms.dialog.textInactivateSlot")
                : t("forms.dialog.textActivateSlot")
            }
            confirmText={t(`forms.dialog.yes`)}
            cancelText={t(`forms.dialog.no`)}
            alert={true}
          />
          <DialogCustom
            open={deleteCommitteeAlertOpened}
            handleClose={() => setDeleteCommitteeAlertOpened(false)}
            handleChange={handleDeleteElevation}
            title={t(`forms.dialog.alert`)}
            body={`${t("forms.dialog.deleteCommitteeAlert")} ${
              committeeList
                ? committeeList.find((item) => item.id === committeeIdToDelere)
                    ?.nameCommittee || ""
                : ""
            }`}
            confirmText={t(`forms.dialog.yes`)}
            cancelText={t(`forms.dialog.no`)}
            alert={true}
          />
        </div>

        <div>
          <DialogCustom
            open={openDelete}
            handleClose={handleCloseDelete}
            handleChange={handleChangeDelete}
            title={t(`forms.dialog.warning`)}
            body={t("forms.dialog.textDeleteSlot")}
            confirmText={t(`forms.dialog.yes`)}
            cancelText={t(`forms.dialog.no`)}
            error={true}
          />
        </div>
      </Grid>

      <Grid container item direction="row" spacing={2}>
        <Grid item xs={12} md={12} lg={9}>
          <Paper elevation={1} style={{ padding: 40, marginBottom: 40 }}>
            <TitleContainer container spacing={3}>
              <Typography className={classes.title}>
                {t("slots.infoSlot")}
              </Typography>

              {!editSlotCommittee && !id && (
                <FormControlLabel
                  disabled={!canCreateExtraSlot || detailSlot}
                  control={
                    <Tooltip title={t("slots.extraSlot")}>
                      <Switch
                        checked={extraSlot}
                        onChange={() => setExtraSlot(!extraSlot)}
                        name="extraSlot"
                        color="primary"
                        tool
                      />
                    </Tooltip>
                  }
                  label={t("slots.extraSlot")}
                />
              )}
            </TitleContainer>

            <Grid container spacing={3}>
              <Grid item lg={4} xs={6}>
                <Select
                  id="requester"
                  disabled={editSlotCommittee || detailSlot}
                  options={requesterOptions || []}
                  value={objValue.requester}
                  setValue={(value) =>
                    setValue({ ...objValue, requester: value })
                  }
                  onInputChange={(_event, newInputValue, _prop) => {
                    setRequesterName(newInputValue);
                  }}
                  inputValue={requesterName}
                  label={t("slots.requester")}
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <Select
                  disabled={editSlotCommittee || detailSlot}
                  id="board"
                  options={sanitizeDirectorsForSelect(directorsList)}
                  value={objValue.board}
                  setValue={(value) => handleChangeSelect(value, "board")}
                  label={t("slots.board")}
                  error={(objValue.board ? false : true) && !anyoneCanHost}
                  required={!anyoneCanHost}
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <KeyboardDatePicker
                  autoOk
                  disableToolbar
                  variant="inline"
                  format={getInputDateFormats(i18n.language)}
                  id="createdIn"
                  fullWidth
                  label={t("slots.createdIn")}
                  value={objValue.createdIn}
                  disabled={true}
                  // onChange={handleDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <Select
                  disabled={editSlotCommittee || detailSlot}
                  id="type"
                  options={typeSlot}
                  value={objValue.type}
                  setValue={(value) => handleChangeSelect(value, "type")}
                  label={t("slots.type")}
                  error={objValue.type ? false : true}
                  required={true}
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <Textarea
                  disabled={editSlotCommittee || detailSlot}
                  name="theme"
                  id="theme"
                  required={true}
                  error={themeValue ? false : true}
                  onChange={(e) => setThemeValue(e.target.value)}
                  value={themeValue}
                  label={t("slots.theme")}
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <Textarea
                  disabled={editSlotCommittee || detailSlot}
                  name="objective"
                  id="objective"
                  onChange={(e) => setObjectiveValue(e.target.value)}
                  value={objectiveValue || ""}
                  error={objectiveValue ? false : true}
                  required
                  label={t("slots.objective")}
                />
              </Grid>

              <Grid item lg={8} xs={12}>
                <TextField
                  disabled={editSlotCommittee || detailSlot}
                  name="institution"
                  id="institution"
                  onChange={handleChange}
                  value={objValue.institution || ""}
                  label={t("slots.institution")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <Select
                  id="modality"
                  options={modalityList.map((item) => ({
                    id: item.id,
                    name: item.name,
                  }))}
                  getOptionSelected={(option, value) => option.id === value.id}
                  value={objValue.modalities}
                  label={t("slots.modality")}
                  setValue={(values) => {
                    setValue({ ...objValue, modalities: values });
                  }}
                  multiple={true}
                  disabled={editSlotCommittee || detailSlot}
                  error={objValue.modalities.length > 0 ? false : true}
                  required={true}
                  renderTags={(selectedValues) => {
                    return selectedValues.map((option) => (
                      <Chip
                        className={classes.chip}
                        key={option.id}
                        disabled={editSlotCommittee || detailSlot}
                        onDelete={() => {
                          setValue({
                            ...objValue,
                            modalities: objValue.modalities.filter(
                              (v) => v.id !== option.id
                            ),
                          });
                        }}
                        onClick={() => {
                          setValue({
                            ...objValue,
                            modalities: objValue.modalities.filter(
                              (v) => v.id !== option.id
                            ),
                          });
                        }}
                        variant="outlined"
                        label={option.name}
                      />
                    ));
                  }}
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <Select
                  disabled={id || editSlotCommittee || detailSlot}
                  id="materialStatus"
                  options={materialSupportStatusOptions}
                  value={objValue.status}
                  setValue={(value) => handleChangeSelect(value, "status")}
                  label={t("slots.statusMaterial")}
                  error={objValue.status ? false : true}
                  required={true}
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <TextField
                  disabled={editSlotCommittee || detailSlot}
                  name="projectIdentifier"
                  id="projectIdentifier"
                  onChange={(e) => {
                    setValue({
                      ...objValue,
                      projectIdentifier: e.currentTarget.value,
                    });
                  }}
                  value={objValue.projectIdentifier || ""}
                  label={t("menu.slot.projectIdentifier")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <Select
                  id="companies"
                  options={companiesOptions.map((item) => ({
                    id: item.companyId,
                    name: `${item.companyName} - ${item.companyAbbreviation}`,
                  }))}
                  getOptionSelected={(option, value) => option.id === value.id}
                  value={objValue.companies}
                  label={t("slots.companies")}
                  setValue={(values) => {
                    setValue({ ...objValue, companies: values });
                  }}
                  required
                  error={objValue.companies.length > 0 ? false : true}
                  multiple={true}
                  onFocus={() => {
                    if (committeeList.length === 0) {
                      setMessage({
                        open: true,
                        content: t(
                          "slots.selectCompaniesBeforeCommitteesError"
                        ),
                        type: "error",
                        autoHideDuration: 4000,
                      });
                    }
                  }}
                  disabled={editSlotCommittee || detailSlot}
                  renderTags={(selectedValues) => {
                    return selectedValues.map((option) => (
                      <Chip
                        className={classes.chip}
                        key={option.id}
                        disabled={editSlotCommittee || detailSlot}
                        onDelete={() => {
                          setValue({
                            ...objValue,
                            companies: objValue.companies.filter(
                              (v) => v.id !== option.id
                            ),
                          });
                        }}
                        onClick={() => {
                          setValue({
                            ...objValue,
                            companies: objValue.companies.filter(
                              (v) => v.id !== option.id
                            ),
                          });
                        }}
                        variant="outlined"
                        label={option.name}
                      />
                    ));
                  }}
                />
              </Grid>
            </Grid>

            <TitleContainer style={{ marginTop: "12px" }} container spacing={3}>
              <Typography
                className={classes.title}
                style={{ marginBottom: "0px" }}
              >
                {t("slots.budget.financialDetails")}
              </Typography>
            </TitleContainer>

            <Grid container spacing={3}>
              <Grid item lg={4} xs={6}>
                <Select
                  disabled={editSlotCommittee || detailSlot}
                  id="currency"
                  options={currencies}
                  value={objValue.currency}
                  setValue={(value) =>
                    setValue({ ...objValue, currency: value })
                  }
                  label={t("menu.slot.currency")}
                />
              </Grid>

              <Grid item lg={8} xs={12}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">
                    {t("slots.budget.title")}
                  </FormLabel>
                  <RadioGroup
                    disabled={editSlotCommittee || detailSlot}
                    aria-label="budget"
                    name="budget"
                    value={objValue.budget || ""}
                    onChange={handleChange}
                    required={true}
                    row
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio size="small" />}
                      label={t("slots.budget.yes")}
                      disabled={editSlotCommittee || detailSlot}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio size="small" />}
                      label={t("slots.budget.no")}
                      disabled={editSlotCommittee || detailSlot}
                    />
                    <FormControlLabel
                      value="na"
                      control={<Radio size="small" />}
                      label={t("slots.budget.na")}
                      disabled={editSlotCommittee || detailSlot}
                    />
                    <FormControlLabel
                      value="pno"
                      control={<Radio size="small" />}
                      label={t("slots.budget.pno")}
                      disabled={editSlotCommittee || detailSlot}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <TitleContainer style={{ marginTop: "12px" }} container spacing={3}>
              <Typography
                className={classes.title}
                style={{ marginBottom: "0px" }}
              >
                {t("slots.budget.label")}
              </Typography>
            </TitleContainer>

            <Grid container spacing={3}>
              <Grid item lg={4} xs={6}>
                <TextField
                  disabled={editSlotCommittee || detailSlot}
                  required={
                    (objValue.budget === "yes" &&
                      !objValue.budgetedValue &&
                      !objValue.multiannualBudgetAmount &&
                      !objValue.amountNotBudgetedYear &&
                      !objValue.requestedValue &&
                      !objValue.value &&
                      !objValue.additive) ||
                    objValue.budget === "pno"
                  }
                  error={
                    (objValue.budget === "yes" &&
                      !objValue.budgetedValue &&
                      !objValue.multiannualBudgetAmount &&
                      !objValue.amountNotBudgetedYear &&
                      !objValue.requestedValue &&
                      !objValue.value &&
                      !objValue.additive) ||
                    (objValue.budget === "pno" && !objValue.budgetedValue)
                  }
                  name="budgetedValue"
                  id="budgetedValue"
                  onChange={(e) => {
                    const formatted = formatCurrencyInputValue(
                      e.currentTarget.value
                    );

                    const isNotNumber =
                      /^[0-9.]+$/.test(e.currentTarget.value) ||
                      e.currentTarget.value === "";

                    setValue({
                      ...objValue,
                      ...(isNotNumber && { budgetedValue: formatted }),
                    });
                  }}
                  value={objValue.budgetedValue || ""}
                  label={t("budgetedValue")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <TextField
                  disabled={editSlotCommittee || detailSlot}
                  required={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive
                  }
                  error={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive &&
                    !objValue.multiannualBudgetAmount
                  }
                  name="multiannualBudgetAmount"
                  id="multiannualBudgetAmount"
                  onChange={(e) => {
                    const formatted = formatCurrencyInputValue(
                      e.currentTarget.value
                    );

                    const isNotNumber =
                      /^[0-9.]+$/.test(e.currentTarget.value) ||
                      e.currentTarget.value === "";

                    setValue({
                      ...objValue,
                      ...(isNotNumber && {
                        multiannualBudgetAmount: formatted,
                      }),
                    });
                  }}
                  value={objValue.multiannualBudgetAmount || ""}
                  label={t("multiannualBudgetAmount")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <TextField
                  disabled={editSlotCommittee || detailSlot}
                  required={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive
                  }
                  error={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive &&
                    !objValue.amountNotBudgetedYear
                  }
                  name="amountNotBudgetedYear"
                  id="amountNotBudgetedYear"
                  onChange={(e) => {
                    const formatted = formatCurrencyInputValue(
                      e.currentTarget.value
                    );

                    const isNotNumber =
                      /^[0-9.]+$/.test(e.currentTarget.value) ||
                      e.currentTarget.value === "";

                    setValue({
                      ...objValue,
                      ...(isNotNumber && { amountNotBudgetedYear: formatted }),
                    });
                  }}
                  value={objValue.amountNotBudgetedYear || ""}
                  label={t("amountNotBudgetedYear")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>
            </Grid>

            <TitleContainer style={{ marginTop: "12px" }} container spacing={3}>
              <Typography
                className={classes.title}
                style={{ marginBottom: "0px" }}
              >
                {t("slots.budget.requested")}
              </Typography>
            </TitleContainer>

            <Grid container spacing={3}>
              <Grid item lg={4} xs={6}>
                <TextField
                  disabled={editSlotCommittee || detailSlot}
                  required={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive
                  }
                  error={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive &&
                    !objValue.requestedValue
                  }
                  name="requestedValue"
                  id="requestedValue"
                  onChange={(e) => {
                    const formatted = formatCurrencyInputValue(
                      e.currentTarget.value
                    );

                    const isNotNumber =
                      /^[0-9.]+$/.test(e.currentTarget.value) ||
                      e.currentTarget.value === "";

                    setValue({
                      ...objValue,
                      ...(isNotNumber && { requestedValue: formatted }),
                    });
                  }}
                  value={objValue.requestedValue || ""}
                  label={t("requestedValue")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <TextField
                  disabled={editSlotCommittee || detailSlot}
                  required={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive
                  }
                  error={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive &&
                    !objValue.value
                  }
                  name="value"
                  id="value"
                  onChange={(e) => {
                    const formatted = formatCurrencyInputValue(
                      e.currentTarget.value
                    );

                    const isNotNumber =
                      /^[0-9.]+$/.test(e.currentTarget.value) ||
                      e.currentTarget.value === "";

                    setValue({
                      ...objValue,
                      ...(isNotNumber && { value: formatted }),
                    });
                  }}
                  value={objValue.value || ""}
                  label={t("value")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <TextField
                  disabled={editSlotCommittee || detailSlot}
                  required={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive
                  }
                  error={
                    objValue.budget === "yes" &&
                    !objValue.budgetedValue &&
                    !objValue.multiannualBudgetAmount &&
                    !objValue.amountNotBudgetedYear &&
                    !objValue.requestedValue &&
                    !objValue.value &&
                    !objValue.additive &&
                    !objValue.additive
                  }
                  name="additive"
                  id="additive"
                  onChange={(e) => {
                    const formatted = formatCurrencyInputValue(
                      e.currentTarget.value
                    );

                    const isNotNumber =
                      /^[0-9.]+$/.test(e.currentTarget.value) ||
                      e.currentTarget.value === "";

                    setValue({
                      ...objValue,
                      ...(isNotNumber && { additive: formatted }),
                    });
                  }}
                  value={objValue.additive || ""}
                  label={t("additive")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item lg={12} xs={6}>
                <Textarea
                  disabled={editSlotCommittee || detailSlot}
                  name="sponsor"
                  id="sponsor"
                  onChange={(e) => {
                    setValue({
                      ...objValue,
                      sponsor: e.target.value,
                    });
                  }}
                  value={objValue.sponsor || ""}
                  label={t("sponsor")}
                />
              </Grid>

              <Grid item lg={8} xs={6}>
                <Textarea
                  name="caveats"
                  id="caveats"
                  onChange={(e) => setCaveatsValue(e.target.value)}
                  value={caveatsValue}
                  label={t("slots.caveats")}
                  disabled={editSlotCommittee || detailSlot}
                />
              </Grid>

              <Grid item lg={4} xs={6}>
                <InputMask
                  mask="99:99"
                  maskChar=""
                  name="duration"
                  onChange={handleChange}
                  value={objValue.duration || ""}
                  disabled={editSlotCommittee || detailSlot}
                >
                  {() => (
                    <TextField
                      fullWidth
                      name="duration"
                      onChange={handleChange}
                      value={objValue.duration || ""}
                      inputProps={{
                        id: "duration",
                      }}
                      label={t("slots.duration")}
                      disabled={editSlotCommittee || detailSlot}
                      required
                      error={objValue.duration ? false : true}
                    />
                  )}
                </InputMask>
              </Grid>

              <Grid item lg={4} xs={6}>
                <KeyboardDatePicker
                  autoOk
                  disableToolbar
                  variant="inline"
                  format={getInputDateFormats(i18n.language)}
                  disabled={detailSlot}
                  id="meetingDate"
                  fullWidth
                  label={t("slots.meetingDate")}
                  value={objValue.meetingDate ?? null}
                  onChange={handleDateChange}
                  required
                  error={objValue.meetingDate && selectedDate ? false : true}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
                {!editSlotCommittee && id && (
                  <FieldInfo>
                    Esse campo será aplicado somente para os comitês adicionados
                    nessa sessão. Sendo assim não terá efeito de atualização
                    para os comitês adicionados anteriormente.
                  </FieldInfo>
                )}
              </Grid>

              <Grid item lg={4} xs={6}>
                <TextField
                  disabled={true}
                  name="statusSlot"
                  id="statusSlot"
                  value={getStatus(slot.status)}
                  label={t("slots.statusSlot")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>
              {slot.creationUser?.name && (
                <Grid item lg={4} xs={6}>
                  <TextField
                    disabled={true}
                    name="slotCreationUser"
                    id="slotCreationUser"
                    value={slot.creationUser?.name ?? ``}
                    label={t("slots.creationUser")}
                    fullWidth
                    autoComplete="nope"
                  />
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>

        <Grid item lg={3}>
          <Grid item>
            <Paper elevation={1} style={{ padding: 20, marginBottom: 10 }}>
              <Typography className={classes.title}>
                {t("slots.presenter")}
              </Typography>

              <Grid item lg={12} xs={12}>
                <FormControlLabel
                  fullWidth
                  disabled={editSlotCommittee || detailSlot}
                  control={
                    <Checkbox
                      disabled={editSlotCommittee || detailSlot}
                      value={anyoneCanHost}
                      checked={anyoneCanHost}
                      onChange={() => {
                        if (!anyoneCanHost) {
                          setValue({ ...objValue, presenter: undefined });
                        }

                        setAnyoneCanHost(!anyoneCanHost);
                      }}
                      name="anyoneCanHost"
                      id="anyoneCanHost"
                      color="primary"
                    />
                  }
                  label={t("menu.slot.anyoneCanHost")}
                />
              </Grid>

              <Grid item lg={12} xs={12}>
                <Select
                  id="host"
                  autoComplete={false}
                  options={presenterOptions}
                  value={objValue.host}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setPresenterName(newInputValue);
                  }}
                  inputValue={presenterName}
                  disabled={editSlotCommittee || anyoneCanHost || detailSlot}
                  label={t("slots.presenter")}
                  setValue={(newValue) => handleAddHost(newValue)}
                />
                {hostList.length > 0 && (
                  <Grid item lg={6} xs={12} style={{ marginTop: 26 }}>
                    {hostList.map((item, index) => (
                      <Grid
                        item
                        lg={12}
                        xs={12}
                        key={`${item} - ${index}`}
                        style={{ marginBottom: 16 }}
                      >
                        <Chip
                          label={item.isExternal ? `${item.name} (Externo)` : item.name}
                          onDelete={() => handleDeleteHost(item.id)}
                          color="primary"
                          disabled={
                            editSlotCommittee || anyoneCanHost || detailSlot
                          }
                          style={item.isExternal ? { borderStyle: "dashed" } : {}}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>

          <Grid item>
            <Paper elevation={1} className={classes.root}>
              <Typography className={classes.title}>
                {t("committees")}
              </Typography>
              <Grid container alignItems="center" spacing={3}>
                <Grid item lg={12} xs={12}>
                  <Select
                    id="committee"
                    autoComplete={false}
                    options={committeesOptions}
                    setValue={(newValue) => handleAddCommittee(newValue)}
                    value={{}}
                    disabled={editSlotCommittee || detailSlot}
                    label={t("committees")}
                  />
                </Grid>

                {committeeList.length > 0 && (
                  <Grid item lg={12} xs={12} style={{ marginTop: 26 }}>
                    {committeeList.map((item) => (
                      <CommitteCard
                        key={item.id}
                        name={item.nameCommittee}
                        onDelete={() => {
                          setCommitteeIdToDelere(item.id);

                          setValue((oldValue) => ({
                            ...oldValue,
                            companies: oldValue.companies.filter((cmp) =>
                              companiesOptions
                                .map((cp) => cp.id)
                                .includes(cmp.id)
                            ),
                          }));
                          setDeleteCommitteeAlertOpened(true);
                        }}
                        onSetFinalElevation={() =>
                          handleSetFinalElevation(item.id)
                        }
                        finalElevation={item.finalAuthority}
                        disabled={editSlotCommittee || detailSlot}
                      />
                    ))}
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      {!detailSlot && (
        <Grid container item direction="row" justify="center" spacing={2}>
          <Grid item>
            <Button
              variant="outlined"
              className={classes.buttonOutlined}
              onClick={() => history.push(returnUrl ? returnUrl : "/slots")}
            >
              {t("cancel")}
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              disabled={
                (!!id && !canUpdateSlot) ||
                (!id && !canCreateSlot) ||
                detailSlot
              }
              onClick={handleSave}
              className={classes.button}
            >
              {t("slots.saveSlot")}
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

const withRouterFormSlot = withRouter(FormSlot);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const FormSlotConnect = connect(null, mapDispatchToProps)(withRouterFormSlot);

export default withTranslation()(FormSlotConnect);
